export const SCORECARD_PARITY_TESTKIT = true;

export const PARITY_SEED = Number(42);

export const PARITY_SOURCE_KEY = "scorecard-parity-compute-source";

export function isParityTestkitEnabled() {
  return (
    process.env.NEXT_PUBLIC_NODE_ENV === "development" ||
    process.env.NEXT_PUBLIC_NODE_ENV === "local"
  )
}

export function readParityComputeSource() {
  if (typeof window === "undefined") return "py";
  try {
    const v = window.localStorage.getItem(PARITY_SOURCE_KEY);
    if (v === "js" || v === "py") return v;
    return "py";
  } catch {
    return "py";
  }
}

/** @param {"js" | "py"} source */
export function writeParityComputeSource(source) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      PARITY_SOURCE_KEY,
      source === "py" ? "py" : "js"
    );
  } catch {
    /* ignore */
  }
}
